import styled from "styled-components";
import { UnprotectedFooterProps } from "./UnprotectedFooter";

export const StyledUnprotectedFooter = styled(
  ({ position, ...props }) => <div {...props} />
)<UnprotectedFooterProps>`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  max-width: 40rem;

  ${({ position }) =>
    position !== "static" &&
    `
    position: relative;
    top: 4rem;
    padding-bottom: 4rem;
  `}
`;

export const StyledContactLink = styled.a`
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    text-decoration-thickness: 2px;
  }
`;
